import axios from 'axios';
import { WgMessage } from 'wg-plus';
import $t from '@/utils/lan';

const http = axios.create({
  baseURL: '/TSAPI/cloudEngineeringSurvey'
  // timeout: 10 * 1000,
});

// 错误码映射
const errorCodeMap = {
  '510000': 'floorDiagramNotExist.msg',
  '510001': 'deleteFloorDiagramFail.msg',
  '510002': 'addPlanFail.msg',
  '510003': 'deletePlanBatchFail.msg',
  '510004': 'planNotExist.msg',
  '510005': 'modifyPlanFail.msg',
  '510006': 'addFloorFail.msg',
  '510007': 'max5FloorsLimit.msg',
  '510009': 'deleteFloorBatchFail.msg',
  '510011': 'floorNotExist.msg',
  '510012': 'modifyFloorFail.msg',
  '510015': 'floorHeightError.msg',
  '510016': 'saveDiagramGeoFail.msg',
  '510017': 'addWaitDeployDeviceFail.msg',
  '510024': 'floorAreaHeightInvalid.msg',
  '510025': 'duplicateFloorName.msg',
  '510026': 'duplicatePlanName.msg',
  '510037': 'max10PlansLimit.msg',
  '510038': 'minPage1Limit.msg'
};
// http.defaults.headers.common['access_token'] =
//   process.env.NODE_ENV === 'development'
//     ? 'eyJhbGciOiJIUzUxMiJ9.eyJ0ZW5hbnRJZCI6IjA4Y2VkMzk0ODNmNTQyNmI4YmQyNGUzMGFlYjBhYzIwIiwic3ViIjoiMDhjZWQzOTQ4M2Y1NDI2YjhiZDI0ZTMwYWViMGFjMjAiLCJsb2dpbkNsaWVudFR5cGUiOiJXRUIiLCJleHAiOjE3NDU4MTkyMjYsImFjY291bnROYW1lIjoiMTc3NTc1NTI2MTMiLCJjcmVhdGVkIjoxNzQ1MjE0NDI2NTA3fQ.lQge-l-wO7CJJkU6XD0CrxCo9aZREQtt18P5aXkzvDzeoGwvNwrDh1B-fCCqhPt2loxinGZMSo2nE0ze28Wwig'
//     : sessionStorage.getItem('accessToken');

// http.defaults.headers.common['refresh_token'] =
//   process.env.NODE_ENV === 'development'
//     ? 'eyJhbGciOiJIUzUxMiJ9.eyJ0ZW5hbnRJZCI6IjA4Y2VkMzk0ODNmNTQyNmI4YmQyNGUzMGFlYjBhYzIwIiwic3ViIjoiMDhjZWQzOTQ4M2Y1NDI2YjhiZDI0ZTMwYWViMGFjMjAiLCJsb2dpbkNsaWVudFR5cGUiOiJXRUIiLCJleHAiOjE3NDY0MjQwMjYsImFjY291bnROYW1lIjoiMTc3NTc1NTI2MTMiLCJjcmVhdGVkIjoxNzQ1MjE0NDI2NTA3fQ.0kCsoyBw4MBjsfOuTQmpN1Xc9jQomny8tGDjXxsOl6ntjfZP4gQcYp1z3E0oUOiYa5kXFrpzLJMhPAHW4Ch1lw'
//     : sessionStorage.getItem('refreshToken');

http.interceptors.response.use(
  response => {
    const { code, message } = response?.data || {};
    // 统一处理报错
    if (code !== 200 && code !== 1) {
      if (code && errorCodeMap[code]) {
        WgMessage({
          type: 'error',
          message: $t(errorCodeMap[code])
        });
      } else if (message) {
        WgMessage({
          type: 'error',
          message: message
        });
      }
    }
    return response.data;
  },
  error => {
    const { status, response } = error;
    if (status === 401) {
      window.location.href = '/login';
    }
  }
);

http.interceptors.request.use(
  config => {
    if (config.headers['Content-Type'] !== 'multipart/form-data') {
      config.headers['Content-Type'] = 'application/json';
    }
    if (!config.specTopo) {
      if (sessionStorage.getItem('Authorization')) {
        config.headers.Authorization = sessionStorage.getItem('Authorization');
      }
    }
    if (!config.url.includes('upload/topology')) {
      // config.headers.Authorization = 'd5f310294fffd9e59394c2ae9d43c0de';
    }
    if (config.url.includes('Common/user/authentication') || config.url.includes('UserAuth/User') || config.url.includes('ESServe/v3/models')) {
      config.baseURL = '/TSAPI'
    }
    if (config.bNotAddPre) {
      config.baseURL = '/TSAPI'
    }
    return config;
  }
 );

export { http };
